import Typography from '@/common/components/base/typography/Typography';
import useModal from '@/common/hooks/useModal';
import InfoImage from '@/modules/Statistics/assets/icons/info.svg?react';
import { Flex } from 'styled-system/jsx';
import { PerformanceTabSummaryProps } from './PerformanceSection.type';
import BarChart from '../charts/BarChart';
import PerformanceModal from '../modals/PerformanceModal';
// import StarImage from '@/modules/Statistics/assets/icons/Star.svg?react';
// import { convertPersian } from '../../utils/convertPersian';

export default function StatisticPerformanceTabSummary({
  title,
  unitText,
  value,
  // countryAvgLabel = 'میانگین کشوری :',
  // countryAvgValue,
  // rate,
  average,
  maxValues,
  labels,
  theme,
  values,
  modalTitle,
  modalDescription,
  integerValues,
}: PerformanceTabSummaryProps) {
  const {
    open: isPerformanceModalOpen,
    closeModal: closePerformanceModal,
    openModal: openPerformanceModal,
  } = useModal();

  return (
    <>
      <Flex flexDirection="column" gap="35px">
        <Flex flexDirection="column" gap="8px">
          <Flex justifyContent="space-between">
            <Flex alignItems="center" gap="4px">
              <Typography textStyle="b1" color="black">
                {title}
              </Typography>
              <InfoImage
                width={16}
                height={16}
                onClick={openPerformanceModal}
              />
            </Flex>
            <Flex alignItems="center" gap="4px">
              <Typography fontSize={18} color="black">
                {value}
              </Typography>
              <Typography textStyle="b2" color="black-3">
                {unitText}
              </Typography>
            </Flex>
          </Flex>
          {
            // <Flex justifyContent="space-between">
            //   <Flex alignItems="center" gap="6px">
            //     <Typography color="#7D67E8" fontWeight="bold" textStyle="b2">
            //       - -
            //     </Typography>
            //     <Typography textStyle="b2" color="#787878">
            //       {countryAvgLabel}
            //     </Typography>
            //     <Flex alignItems="center" gap="4px">
            //       <Typography textStyle="b2" color="black">
            //         {countryAvgValue}
            //       </Typography>
            //       <Typography textStyle="b2" color="black-3">
            //         {unitText}
            //       </Typography>
            //     </Flex>
            //   </Flex>
            //
            //   <Flex
            //     gap="4px"
            //     justifyContent="center"
            //     alignItems="center"
            //     padding="6px 8px"
            //     borderRadius="8px"
            //     backgroundColor="#FFF4CF"
            //   >
            //     <Typography color="#D9AA04" textStyle="b2" fontWeight="bold">
            //       {convertPersian(rate ?? 0)}
            //     </Typography>
            //     <StarImage width={12} height={12} />
            //   </Flex>
            // </Flex>
          }
        </Flex>

        <BarChart
          labels={labels}
          values={values}
          average={average}
          theme={theme}
          maxValues={maxValues}
          integerValues={integerValues}
        />
      </Flex>
      <PerformanceModal
        title={modalTitle}
        description={modalDescription}
        closeModal={closePerformanceModal}
        open={isPerformanceModalOpen}
      />
    </>
  );
}
